import { CheckIcon, CopyIcon } from "../../../assets/icons"
import cx from "classnames"
import PropTypes from "prop-types"
import { useState } from "react"

import styles from "./index.module.css"

export const AddressBox = ({
  url,
  account,
  truncate = 8,
  onCopy = () => {},
  copyIcon = CopyIcon,
  successIcon = CheckIcon,
}) => {
  const [isCopied, setIsCopied] = useState(false)

  const accountLength = account ? account.length : 0
  const content =
    truncate >= accountLength / 2
      ? account
      : `${account.slice(0, truncate)}...${account.slice(accountLength - truncate, accountLength)}`

  const handleClick = () => {
    navigator.clipboard.writeText(account)
    setIsCopied(true)
    onCopy()
    setTimeout(() => {
      setIsCopied(false)
    }, 10000)
  }

  return (
    <div className={styles.container} onClick={handleClick}>
      <div className={styles.account}>
        {url ? (
          <a href={url} target="_blank" rel="noopener noreferrer">
            {content}
          </a>
        ) : (
          content
        )}
      </div>
      <div
        className={cx(styles.icon, {
          [styles.success]: isCopied,
        })}
      >
        {isCopied ? successIcon() : copyIcon()}
      </div>
    </div>
  )
}

AddressBox.displayName = "AddressBox"
AddressBox.propTypes = {
  truncate: PropTypes.number,
  account: PropTypes.string.isRequired,
}
